module.exports = __webpack_public_path__ + "img/go_luck_draw_button.87d7e2b2.png";